export default "__VITE_ASSET__6109b9a8__"